module.exports = __webpack_public_path__ + "1d57582d01070cefa9ecd6b8041732ed.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background/campfire.mp3
// module id = 3259
// module chunks = 0